import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'

const ScrollTopCmp = ({ location, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  return children
}

ScrollTopCmp.propTypes = {
  location: PropTypes.object,
  children: PropTypes.any,
}

export const ScrollTop = compose(withRouter)(ScrollTopCmp)
